var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "p-t-xs-20 p-b-xs-20" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c(
        "div",
        { staticClass: "bg--white border-radius m-t-25 m-b-25 p-30" },
        [
          _c("h1", [_vm._v("\n                Dashboard\n            ")]),
          _vm._v(" "),
          _c("Notifications", { staticClass: "dasboard-widget" }),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-lg-6" },
              [
                _c("CandidatePartners", { staticClass: "dasboard-widget" }),
                _vm._v(" "),
                _c("CandidateOffers", { staticClass: "dasboard-widget" }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-lg-6" },
              [
                _c("OilPriceTable", { staticClass: "dasboard-widget" }),
                _vm._v(" "),
                _c("CarAttest", { staticClass: "dasboard-widget" }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }